import { observeLazySources, observeResourcesInContainer } from './modules/lazy-sources-loader.js';
import { loadMore } from './modules/load-more';

/* need for old browsers without defer */
document.addEventListener(
  `DOMContentLoaded`,
  () => {
    /* initialization of lazy loading */
    const lazySourceObserver = observeLazySources();

    const $loadMoreButton = document.querySelector(`.js-load-more-button`);
    const $articlesContainer = document.querySelector(`.js-articles`);

    loadMore(
      $articlesContainer,
      $loadMoreButton,
      (nextPage) =>
        `${window.Site.fullDomain}/ajax/posts/?page=${nextPage}&expert_id=${window.Site.entity_id}`,
      () => observeResourcesInContainer(lazySourceObserver)($articlesContainer),
    );
  },
  false,
);
